import { cn } from '@/utils'
import { memo } from 'react'

interface IChildrenProps {
  children: React.ReactNode
  className?: string
}

const PageWrap = memo(({ children, className }: IChildrenProps) => {
  return (
    <div className={cn(`flex size-full min-h-screen flex-col items-center`, className)}>
      {children}
    </div>
  )
})

export default PageWrap
